/**
 * WalletVault - Secure Wallet Management Service
 *
 * Professional wallet storage system for:
 * - Bundle launch wallets
 * - Aged wallets for trust building
 * - Profit-taking wallets
 * - Airdrop distribution wallets
 *
 * Features:
 * - AES-256-GCM encrypted local storage
 * - PBKDF2 key derivation
 * - Auto-lock after inactivity
 * - Wallet categorization & tagging
 * - Balance tracking
 * - Transaction history
 * - Export/Import with encryption
 */

import WalletVaultService from './WalletVaultService';
export { WALLET_CATEGORIES, WALLET_STATUS, AUTH_TYPES } from './constants';
export { WalletVaultService };
export { getUnlockChallengeMessage, deriveKeyFromSignature } from './cryptoUtils';

// Singleton instance
const walletVault = new WalletVaultService();

export { walletVault };
export default walletVault;
